<template>
  <v-row no-gutters class="pr-2">
    <v-col cols="12" class="pb-3">
      <v-select
        hide-details
        :items="[{label: $t('general.verified'), value: 'true'}, {label: $t('general.notVerified'), value: 'false'}]"
        clearable
        background-color="kbLight"
        color="kbDarkBlueText"
        item-text="label"
        item-value="value"
        :label="$t('general.state')"
        solo
        v-model="advancedSearch.verified"
      />
    </v-col>

    <v-col cols="12" class="pb-3">
      <v-select
        hide-details
        :items="[{label: $t('general.imported'), value: '1'}, {label: $t('general.notImported'), value: '0'}]"
        clearable
        background-color="kbLight"
        color="kbDarkBlueText"
        item-text="label"
        item-value="value"
        :label="$t('general.imported')"
        solo
        v-model="advancedSearch.isImported"
      />
    </v-col>

    <v-col cols="12" class="pb-3">
      <v-select
        :items="roles"
        item-color="kbDarkBlueText"
        chips
        clearable
        background-color="kbLight"
        color="kbDarkBlueText"
        deletable-chips
        dense
        hide-details
        item-text="name"
        item-value="id"
        :label="$t('general.roles')"
        multiple
        solo
        v-model="advancedSearch.roles"
      />
    </v-col>

    <v-col cols="12" class="pb-3">
      <v-select
        hide-details
        background-color="kbLight"
        clearable
        color="kbDarkBlueText"
        :items="journeys"
        item-color="kbDarkBlueText"
        item-text="name"
        item-value="id"
        :label="$t('general.journey')"
        multiple
        solo
        v-model="advancedSearch.journeyArray"/>
    </v-col>

    <v-col class="pb-3" cols="12" v-if="filteredAdministrators.length > 0">
      <v-select
        clearable
        hide-details
        background-color="kbLight"
        color="kbDarkBlueText"
        :items="filteredAdministrators"
        item-color="kbDarkBlueText"
        item-text="fullName"
        item-value="userId"
        :label="$t('general.responsible')"
        multiple
        solo
        v-model="advancedSearch.filterResponsible"/>
    </v-col>

    <v-col cols="12" class="pb-3" v-if="usersLikings.length > 0" >
      <v-autocomplete
        v-model="advancedSearch.usersLikings.or"
        item-color="kbDarkBlueText"
        :items="usersLikings"
        :menu-props="{maxHeight: 200}"
        item-text="description"
        item-value="name"
        hide-details
        :label="$t('general.likes')"
        :no-data-text="$t('general.noLikesFound')"
        v-pointer-on-append-icon
        chips
        clearable
        background-color="kbLight"
        color="kbDarkBlueText"
        deletable-chips
        dense
        open-on-clear
        solo
        multiple
      />
    </v-col>

    <v-col cols="12" class="pb-3"  v-if="topGenres.length > 0">
      <v-autocomplete
        v-model="advancedSearch.spotifyGenres.or"
        background-color="kbLight"
        color="kbDarkBlueText"
        :items="topGenres"
        :menu-props="{maxHeight: 200}"
        hide-details
        item-color="kbDarkBlueText"
        item-text="name"
        item-value="name"
        :label="$t('general.musicalGenres')"
        :no-data-text="$t('general.noMusicalGenresFound')"
        v-pointer-on-append-icon
        chips
        clearable
        deletable-chips
        dense
        open-on-clear
        solo
        multiple
      />
    </v-col>

    <v-col cols="12" class="pb-3" v-if="topArtists.length > 0" >
      <v-autocomplete
        v-model="advancedSearch.spotifyArtists.or"
        :items="topArtists"
        :menu-props="{maxHeight: 200}"
        background-color="kbLight"
        color="kbDarkBlueText"
        item-color="kbDarkBlueText"
        hide-details
        item-text="name"
        item-value="name"
        :label="$t('general.artists')"
        :no-data-text="$t('general.noArtistsFound')"
        v-pointer-on-append-icon
        chips
        clearable
        deletable-chips
        dense
        open-on-clear
        solo
        multiple
      />
    </v-col>

    <v-col cols="12" class="pb-3" v-if="topTracks.length > 0">
      <v-autocomplete
        v-model="advancedSearch.spotifyTracks.or"
        :items="topTracks"
        :menu-props="{maxHeight: 200}"
        background-color="kbLight"
        color="kbDarkBlueText"
        item-color="kbDarkBlueText"
        item-text="name"
        item-value="name"
        hide-details
        :label="$t('general.songs')"
        :no-data-text="$t('general.noSongsFound')"
        v-pointer-on-append-icon
        chips
        clearable
        deletable-chips
        dense
        open-on-clear
        solo
        multiple
      />
    </v-col>

    <v-col cols="12">
      <ExtraDataFilters
        :extra-data-labels="extraDataLabels"
        :extra-data-values="advancedSearch.extradata"
        :selected-extra-data-prop="advancedSearch.selectedExtradata"
        @onExtraDataValueChange="changeExtraDataValue"
        @onSelectedExtraDataChange="advancedSearch.selectedExtradata = $event"
      />
    </v-col>

    <v-col cols="12" class="pt-5">
      <span class="kbDarkBlueText--text">
        {{ $t('general.typeOfRegister') }}
      </span>
    </v-col>

    <v-col cols="12" class="d-flex align-center flex-wrap">
      <v-btn v-for="button in socialNetworks"
             :key="button.value"
             icon
             large
             @click="toggleSocialNetworkButton(button.value)">
        <v-icon :color="isSelected(button.value) !== -1 ? button.color : 'grey'">
          {{ button.icon }}
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import ExtraDataFilters from '@/pages/App/People/Filters/ExtraDataFilters'
export default {
  components: { ExtraDataFilters },
  computed: {
    ...mapGetters(['administrators', 'appUuid', 'companyUuid', 'isSearching', 'administratorRoles']),
    ...mapState({
      administrators: state => state.companies.administrators,
      advancedSearch: state => state.users.advancedSearch,
      journeys: state => state.journey.journeys,
      paginationUsers: state => state.users.paginationUsers,
      roles: state => state.roles.roles,
      selectedPeopleDirectoryHeaders: state => state.dataTables.selectedPeopleDirectoryHeaders,
      topGenres: state => state.apps.spotifyUsersTopGenres,
      topArtists: state => state.apps.spotifyUsersTopArtists,
      topTracks: state => state.apps.spotifyUsersTopTracks,
      users: state => state.users.users,
      userKeybe: state => state.auth.userKeybe,
      usersLikings: state => state.apps.instagramUsersLikings
    }),
    filteredAdministrators () {
      return Array.isArray(this.administrators) ? this.administrators : []
    }
  },
  async created () {
    this.$store.commit('SET_PAGINATION_USERS_COMPANY', {
      page: 1,
      itemsPerPage: 300,
      sortBy: [],
      sortDesc: []
    })
    await Promise.all([
      this.getJourneys(),
      this.setAdvancedSearch(),
      this.getAdministrators()
    ])
    this.extraDataLabels = await this.$store.dispatch('getExtradataLabels') || []
    this.canSearch = true
    this.checkLikingsOrSpotifyTagsInQueryParams()
  },
  data () {
    return {
      canSearch: false,
      canCreateList: false,
      extraDataLabels: [],
      isClearingSearchFields: false,
      loadingUsers: false,
      socialNetworks: [
        { icon: 'fab fa-facebook', value: 'facebook', color: 'facebook' },
        { icon: 'fab fa-google', value: 'google', color: 'google' },
        { icon: 'fab fa-instagram', value: 'instagram', color: 'instagram' },
        { icon: 'fab fa-spotify', value: 'spotify', color: 'spotify' },
        { icon: 'email', value: 'email', color: 'email' },
        { icon: 'phone', value: 'phone', color: 'phone' }
      ]
    }
  },
  destroyed () {
    this.$store.commit('CLEAR_ADVANCED_SEARCH')
    this.$store.commit('SET_SEARCH_USERS', '')
  },
  directives: {
    'pointer-on-append-icon': {
      // directive to add cursor pointer property to dropdown button
      bind: function (el, binding, vnode) {
        const icon = el.querySelector(
          '.v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner > .v-input__icon.v-input__icon--append > i.v-icon'
        )
        icon.classList.add('v-icon--link')
      }
    }
  },
  methods: {
    changeExtraDataValue ({ key, value }) {
      this.$set(this.advancedSearch.extradata, key, value)
    },
    checkLikingsOrSpotifyTagsInQueryParams () {
      const { query } = this.$route
      const queryKeys = Object.keys(query)
      if (queryKeys.length > 0) {
        let areFiltersShown = false
        if (queryKeys.includes('spotifyGenres')) {
          this.advancedSearch.spotifyGenres.or.push(query.spotifyGenres)
          areFiltersShown = true
        } else if (queryKeys.includes('spotifyArtists')) {
          this.advancedSearch.spotifyArtists.or.push(query.spotifyArtists)
          areFiltersShown = true
        } else if (queryKeys.includes('spotifyTracks')) {
          this.advancedSearch.spotifyTracks.or.push(query.spotifyTracks)
          areFiltersShown = true
        } else if (queryKeys.includes('usersLikings')) {
          this.advancedSearch.usersLikings.or.push(query.usersLikings)
          areFiltersShown = true
        }
        if (areFiltersShown) {
          this.$emit('openPeopleFilters')
        }
      }
    },
    cleanExtraDataValues () {
      /* Deleting this.advancedSearch.extradata properties if
         this.advancedSearch.selectedExtradata doesn't includes them */
      if (this.advancedSearch.extradata &&
          typeof this.advancedSearch.extradata === 'object') {
        for (const key in this.advancedSearch.extradata) {
          if (!this.advancedSearch.selectedExtradata.includes(key)) {
            this.$delete(this.advancedSearch.extradata, key)
            // delete this.advancedSearch.extradata[key]
          }
        }
      }
    },
    async getAdministrators () {
      if (this.userKeybe.type === 'superadmin' || this.administratorRoles.includes('ROLE_RECORDS_VIEW_ALL')) {
        await this.$store.dispatch('getAdministrators')
      } else {
        return null
      }
    },
    async getJourneys () {
      await this.$store.dispatch('getJourneys', {
        companyId: this.companyUuid,
        appId: this.appUuid
      })
    },
    async getUsers () {
      if (!this.canSearch) return
      try {
        this.loadingUsers = true
        this.$store.commit('SET_PAGINATION_USERS', {
          page: 1,
          itemsPerPage: this.paginationUsers.itemsPerPage,
          sortBy: this.paginationUsers.sortBy,
          descending: this.paginationUsers.descending
        })
        await this.$store.dispatch('getUsers', { headers: this.selectedPeopleDirectoryHeaders })
        this.loadingUsers = false
      } catch (e) {
        this.loadingUsers = false
        notifications.error(e)
        throw e
      }
    },
    isSelected (typeRegister) {
      return this.advancedSearch.socialNetworks.indexOf(typeRegister)
    },
    remove (item, listExtraData) {
      const index = listExtraData.findIndex(header => header.value === item.value)
      if (index >= 0) {
        listExtraData.splice(index, 1)
        delete listExtraData[item.field]
      }
    },
    removeFromList (item, listExtraData) {
      const index = listExtraData.indexOf(item)
      if (index >= 0) {
        delete listExtraData[item.field]
      }
    },
    removeAll () {
      this.$store.commit('CLEAR_EXTRADATA')
    },
    async setAdvancedSearch () {
      this.$store.commit('CLEAR_ADVANCED_SEARCH')
      const typeRegister = this.$route.query.typeRegister
      this.$set(this.advancedSearch, 'isImported', undefined)
      if (
        typeRegister &&
          typeRegister !== 'total' &&
          typeRegister !== 'imported'
      ) {
        this.$set(this.advancedSearch.socialNetworks, 0, typeRegister)
      } else if (typeRegister && typeRegister === 'imported') {
        this.$set(this.advancedSearch, 'isImported', '1')
      }
      await Promise.all([
        this.$store.dispatch('getRoles'),
        this.$store.dispatch('getInstagramUsersLikings'),
        this.$store.dispatch('getUsersSpotifyTopGenres'),
        this.$store.dispatch('getUsersSpotifyTopArtists'),
        this.$store.dispatch('getUsersSpotifyTopTracks')
      ])
    },
    toggleSocialNetworkButton (typeRegister) {
      if (this.advancedSearch.socialNetworks.length > 0) {
        const index = this.advancedSearch.socialNetworks.indexOf(typeRegister)
        if (index !== -1) {
          this.advancedSearch.socialNetworks.splice(index, 1)
        } else {
          this.advancedSearch.socialNetworks.push(typeRegister)
        }
      } else {
        this.advancedSearch.socialNetworks.push(typeRegister)
      }
    }
  },
  watch: {
    'advancedSearch.roles' () {
      this.getUsers()
    },
    'advancedSearch.filterResponsible' () {
      this.getUsers()
    },
    'advancedSearch.journeyArray' () {
      this.getUsers()
    },
    'advancedSearch.socialNetworks' () {
      this.getUsers()
    },
    'advancedSearch.usersLikings.or' () {
      this.getUsers()
    },
    'advancedSearch.spotifyGenres.or' () {
      this.getUsers()
    },
    'advancedSearch.spotifyArtists.or' () {
      this.getUsers()
    },
    'advancedSearch.spotifyTracks.or' () {
      this.getUsers()
      if (!this.canSearch) return
      this.getUsers()
    },
    'advancedSearch.extradata': {
      handler () {
        if (!this.canSearch) return
        this.getUsers()
      },
      deep: true
    },
    'advancedSearch.selectedExtradata' () {
      this.cleanExtraDataValues()
    },
    'advancedSearch.verified' () {
      this.getUsers()
    },
    'advancedSearch.isImported' () {
      this.getUsers()
    }
  }
}
</script>
